import React from "react";
import logoPurissima from "../assets/images/svg/unicornio-brown.svg";

const Spinner = ({
  title,
  message,
  subtitle,
  minHeight = "260px",
  size = "md",
  showLogo = true,
  className = "",
  style = {},
  fullScreen = false,
}) => {
  const displayTitle = title || message || "Carregando...";
  const isSmall = size === "sm";

  const fullScreenStyle = fullScreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "var(--beige-bg, #E6DDCE)",
        zIndex: 999999,
        margin: 0,
        padding: 0,
      }
    : { minHeight };

  return (
    <div
      className={`purissima-loading d-flex flex-column align-items-center justify-content-center text-center ${fullScreen ? "" : "py-4"} ${className}`}
      style={{ ...fullScreenStyle, ...style }}
      role="status"
      aria-live="polite"
    >
      {showLogo && (
        <div className="purissima-loading-brand-wrapper mb-3">
          <img
            src={logoPurissima}
            alt="Puríssima"
            className="purissima-loading-brand"
            style={{
              width: isSmall ? "42px" : "64px",
              height: "auto",
              opacity: 0.95,
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      )}
      <div
        className="spinner-border mb-3"
        aria-hidden="true"
        style={{
          width: isSmall ? "1.25rem" : "1.65rem",
          height: isSmall ? "1.25rem" : "1.65rem",
          color: "#446D41",
          borderWidth: isSmall ? "2px" : "2.5px",
        }}
      />
      {displayTitle && (
        <h5
          className="text-uppercase mb-0"
          style={{
            color: "#3D2C06",
            fontWeight: "700",
            fontSize: isSmall ? "0.82rem" : "0.92rem",
            letterSpacing: "0.8px",
            fontFamily: "'Open Sans', sans-serif",
            margin: 0,
          }}
        >
          {displayTitle}
        </h5>
      )}
    </div>
  );
};

export { Spinner as PurissimaLoading };
export default Spinner;
